<template>
  <section id="div-app">
    <router-view />
  </section>
</template>

<script>
export default {
  name: "app"
};
</script>

<style type="text/scss" lang="scss">
$primary: #000000 !default;

$theme-colors: (
  "primary": #000,
  "black": #000,
  "light-gray": #f5f5f5,
  "gray": #a6a6a6,
  "dark-gray": #666666
);

$font-weight-bold: 700;

@import "../node_modules/bootstrap/scss/bootstrap";
@import "../node_modules/bootstrap-vue/src/index.scss";

@font-face {
  font-family: "Gilroy-Bold";
  src: url("./assets/fonts/3361C6_5_0.woff");
}

html,
body,
#div-app {
  height: 100%;
}

.h-100-trim-header {
  height: calc(100% - 56px) !important;
}

.h-100-trim-header-footer {
  height: calc(100% - 56px - 74px) !important;
}

@import "./assets/css/tailie.css";
h1,
h2,
h3,
h4,
h5 {
  color: #000000 !important;
}

.bg-light-grey {
  /*background-color: #f5f5fa;*/
  background-color: #f2f3f7;
}

.form-group .tailie-input {
  border-radius: 0px;
}

#player {
  max-width: 100% !important;
}

.tailieLoginBenefitsCol {
  margin-bottom: 25px;
}

.tailieLoginBenefitsCol h4 {
  font-size: 16px !important;
}

.btn {
  border-radius: 0px;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.2);
}

#tailieForgotPassword {
  box-shadow: none;
  border: none;
}

#tailieForgotPassword,
#button-close {
  box-shadow: none;
  border: none;
}

button {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.2) !important;
  border-color: #46659b !important;
}

.btn-link {
  padding: 10px 0px !important;
  border: none;
  box-shadow: none;
}

#tailieCollapseUp,
.collapsed #tailieCollapseDown {
  display: inline-block;
}

.collapsed #tailieCollapseUp,
#tailieCollapseDown {
  display: none;
}

.tailieButton:hover,
.tailieCollapse:hover {
  cursor: pointer;
}

/*button:hover:not(.btn-link) {*/
/*  color: #2fb5d2 !important;*/
/*}*/
.tailieCollapse {
  padding-bottom: 10px;
  display: block;
}

#tailieWidget .tailie-input:focus {
  box-shadow: none;
}

.padding-left {
  padding-left: 0px;
}

.padding-none {
  padding: 0px;
}
</style>
